/** What somebody typed as their second factor, and which kind it is. */
export interface SecondFactorValue {
  kind: 'code' | 'recoveryCode'
  text: string
}

export const SECOND_FACTOR_EMPTY: SecondFactorValue = { kind: 'code', text: '' }

/** The value as a mutation takes it. */
export const secondFactorInput = (
  value: SecondFactorValue,
): { code: string } | { recoveryCode: string } =>
  value.kind === 'code'
    ? { code: value.text.trim() }
    : { recoveryCode: value.text.trim() }
